import qs from 'query-string';

import { maxImageRatio, sizeRatioMap } from './constants';
import { parseCountryCodesInPartialNumber } from '../FormQuestion/helper';

import type { ImageSize } from '$lib/types/Components/SharedTypes';
import type { FormValues } from '$lib/types/Form';

export const getHostname = (url: string) => new URL(url).hostname;

export const getParamsFromUrl = (url: string): { [key: string]: string } | undefined => {
    if (!url) return;

    const parts = url.split('?');
    let result = {};

    if (parts.length > 1) {
        const query = parts[1];

        result = qs.parse(query);
    }

    return result;
};

export const deleteIrrelevantImgixKeys = (url: string): string | undefined => {
    if (!url) return;

    const parts = url.split('?');

    if (parts.length > 1) {
        const query = qs.parse(parts[1]);

        delete query.ixid;
        delete query.ixlib;
        delete query.q;
        delete query.w;

        return `${parts[0]}?${qs.stringify(query)}`;
    }

    return url;
};

export const getRatioBySize = ({
    height,
    width,
    size,
}: {
    height?: number;
    width?: number;
    size: ImageSize;
}): number | undefined => {
    if (size !== 'custom') {
        return sizeRatioMap[size];
    } else if (height && width) {
        const ratio = (height * 100) / width;

        return Math.min(ratio, maxImageRatio);
    }
};

// This function strips the crop params maintaing all other params
// crop, cropHeight, cropWidth, dpr, fit, fp-x, fp-y, fp-z, h, w
export const stripCropParams = (src: string): string => {
    const cropParams = [
        'crop',
        'cropHeight',
        'cropWidth',
        'dpr',
        'fit',
        'fp-x',
        'fp-y',
        'fp-z',
        'h',
        'w',
    ];
    const url = new URL(src);
    cropParams.forEach((param) => {
        url.searchParams.delete(param);
    });

    return url.toString();
};

export const sanitizeValues = (
    values: FormValues,
    isNewPhoneField: boolean | undefined,
    isPhoneVerificationCodeField: boolean | undefined,
) => {
    // add protocol to website url if necessary
    if (values['website']) {
        let url = values['website'] as string;

        if (!url.startsWith('http://') && !url.startsWith('https://')) {
            url = 'https://' + url;
        }

        values['website'] = url;
    }

    // clear phone field if only phone country code is entered
    if (
        values['phone'] &&
        (isNewPhoneField || isPhoneVerificationCodeField) &&
        parseCountryCodesInPartialNumber(values['phone'] as string)?.isPhoneCodeOnly
    ) {
        values['phone'] = '';
    }

    // Trim all string values
    Object.keys(values).forEach((key) => {
        if (typeof values[key] === 'string') {
            values[key] = (values[key] as string).trim();
        }
    });

    return values;
};
